(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brit29-b2b"]) return;
  try {
    
(function () {
  function initDirectEmail(){
    const root=document.querySelector('[data-bp-root]'),box=root&&root.querySelector('[data-brit-direct-email]');if(!box||box.dataset.emailReady)return;box.dataset.emailReady='true';
    const link=box.querySelector('[data-brit-email-compose]'),note=box.querySelector('[data-brit-email-explanation]');
    const copy={en:['Write an email to info','This opens your email app with your selected products and market. Review the message and press Send there. If you do not use an email app, copy the address below into your webmail. This does not submit the website form.'],fr:['Écrire un e-mail à info','Ce lien ouvre votre application de messagerie avec les produits sélectionnés et votre marché. Vérifiez le message et cliquez sur Envoyer dans cette application. Sans application de messagerie, copiez l’adresse ci-dessous dans votre webmail. Ce lien ne soumet pas le formulaire du site.'],ar:['كتابة رسالة إلى info','يفتح هذا الخيار تطبيق بريدك مع المنتجات والسوق المختارين. راجع الرسالة واضغط إرسال داخل تطبيق البريد. إذا لم تستخدم تطبيق بريد، انسخ العنوان أدناه إلى بريدك عبر المتصفح. هذا الخيار لا يرسل نموذج الموقع.']};
    const clean=value=>String(value||'').replace(/[\r\n]+/g,' ').trim();
    function payload(){
      const lines=['Britanica B2B enquiry'];
      const company=clean(root.querySelector('#bp-company')?.value),market=clean(root.querySelector('#bp-market')?.value);
      if(company)lines.push('Company: '+company);if(market)lines.push('Market: '+market);
      root.querySelectorAll('[data-bp-product-row]').forEach(row=>{
        if(row.hidden)return;const product=clean(row.querySelector('[data-bp-product]')?.value);if(!product)return;
        const quantity=clean(row.querySelector('[data-bp-quantity]')?.value),pack=clean(row.querySelector('[data-bp-pack]')?.value),container=clean(row.querySelector('[data-bp-container]')?.value);
        const parts=[product];if(quantity)parts.push(quantity+' containers');if(pack)parts.push('pack: '+pack);if(container)parts.push('container: '+container);lines.push(parts.join(' | '));
      });
      const notes=String(root.querySelector('#bp-message')?.value||'').trim();if(notes)lines.push('Message: '+notes);
      return 'mailto:info@britanicahealth.com?subject='+encodeURIComponent('Britanica B2B enquiry')+'&body='+encodeURIComponent(lines.join('\n'));
    }
    function refresh(){
      const lang=(new URL(location.href).searchParams.get('brit_ui_lang')||document.documentElement.lang||'en').slice(0,2),words=copy[lang]||copy.en;
      if(link.textContent!==words[0])link.textContent=words[0];if(note.textContent!==words[1])note.textContent=words[1];box.lang=lang;box.dir=lang==='ar'?'rtl':'ltr';const href=payload();if(link.getAttribute('href')!==href)link.setAttribute('href',href);
    }
    root.addEventListener('input',refresh);root.addEventListener('change',refresh);link.addEventListener('click',refresh);
    document.addEventListener('britanica:language-preview',function(){requestAnimationFrame(refresh);});refresh();
  }
  function initPartnerPage() {
    const root=document.querySelector('[data-bp-root]');
    if(!root||root.dataset.bpReady)return;
    const form=root.querySelector('#B2BRequestForm');
    if(!form)return;
    root.dataset.bpReady='true';root.classList.add('is-enhanced');
    const rows=Array.from(root.querySelectorAll('[data-bp-product-row]'));
    const add=root.querySelector('[data-bp-add]');
    const choices=Array.from(root.querySelectorAll('[data-bp-choice]'));
    const names=choices.map(i=>i.value);
    const state=new Map();
    const params=new URLSearchParams(location.search);
    const primaryPacks={multibrix:{count:'90',text:'90 tablets'},dcaredrops:{count:'30 mL',text:'30 mL'},brimagkids:{count:'30 mL',text:'30 mL'},prowoman:{count:'60',text:'60 capsules'},proman:{count:'30',text:'30 capsules'},bricarnit:{count:'60',text:'60 capsules'},brifol:{count:'90',text:'90 tablets'},pregnancal:{count:'30',text:'30 tablets'},briplex:{count:'60',text:'60 tablets'},ferrochalplus:{count:'30',text:'30 tablets'},ferrochalultra:{count:'30',text:'30 tablets'},osteacal:{count:'30',text:'30 tablets'},calvid:{count:'30',text:'30 tablets'},codliv:{count:'60',text:'60 softgels'},dcare1000:{count:'30',text:'30 softgels'},glucojoint:{count:'60',text:'60 tablets'},collago:{count:'30',text:'30 capsules'},glucojointplus:{count:'60',text:'60 capsules'},omegal3plus:{count:'90',text:'90 softgels'},omega3plus:{count:'90',text:'90 softgels'}};
    const normalize=value=>{let v=String(value).toLowerCase().replace(/[^a-z0-9]/g,'');return v==='prowomen'?'prowoman':v==='omega3plus'?'omegal3plus':v;};
    const primaryFor=value=>primaryPacks[normalize(value)];
    const translate=value=>window.BritCommercialLanguage?.translate(value)||value;
    const field=row=>({product:row.querySelector('[data-bp-product]'),quantity:row.querySelector('[data-bp-quantity]'),pack:row.querySelector('[data-bp-pack]'),container:row.querySelector('[data-bp-container]'),error:row.querySelector('[data-bp-error]')});
    function validate(row,show){
      const f=field(row),active=!row.hidden&&Boolean(f.product.value),value=f.quantity.value.trim();
      const quantityValid=!active||(/^\d+$/.test(value)&&Number.isSafeInteger(Number(value))&&Number(value)>=3000&&Number(value)%1000===0);
      const primary=primaryFor(f.product.value),packValid=!active||Boolean(primary?f.pack.value===primary.count:f.pack.value==='To be confirmed');
      const duplicates=rows.filter(r=>!r.hidden&&field(r).product.value===f.product.value).length>1;
      f.product.setCustomValidity(active&&duplicates?translate('This product is already in your selection.'):'');
      f.quantity.setCustomValidity(quantityValid?'':root.dataset.bpQuantityError);
      f.pack.setCustomValidity(packValid?'':translate('Pack confirmation required'));
      f.error.textContent=show&&!quantityValid?root.dataset.bpQuantityError:'';
      if(show&&active)f.quantity.setAttribute('aria-invalid',String(!quantityValid));else f.quantity.removeAttribute('aria-invalid');
      return quantityValid&&packValid&&!duplicates;
    }
    function sync(row){
      const f=field(row),active=!row.hidden&&Boolean(f.product.value),primary=primaryFor(f.product.value);
      [f.quantity,f.pack,f.container].forEach(i=>{i.disabled=!active;i.required=active;});
      if(primary&&!Array.from(f.pack.options).some(o=>o.value===primary.count)){
        const o=document.createElement('option');o.value=primary.count;o.textContent=primary.text;f.pack.append(o);
      }
      for(const o of f.pack.options){
        if(!o.value)continue;
        if(!o.dataset.originalText)o.dataset.originalText=o.textContent;
        const allowed=primary?o.value===primary.count:o.value==='To be confirmed';
        o.disabled=!allowed;o.hidden=!allowed;
        o.textContent=primary&&allowed?translate(primary.text):o.dataset.originalText;
      }
      if(active){
        f.pack.value=primary?primary.count:'To be confirmed';
        if(!f.quantity.value)f.quantity.value='3000';
        for(const o of f.container.options)if(o.value==='Packages')o.textContent=translate('Other container format — subject to written confirmation');
        if(!f.container.value)f.container.value=normalize(f.product.value)==='prowoman'?'Bottles':'To be confirmed';
      }else{f.quantity.value='';f.pack.value='';f.container.value='';}
      validate(row,false);
    }
    function snapshot(){
      state.clear();
      for(const row of rows){const f=field(row);if(!row.hidden&&f.product.value)state.set(f.product.value,{quantity:f.quantity.value,container:f.container.value});}
    }
    function summary(requestedLanguage){
      const active=rows.filter(r=>!r.hidden&&field(r).product.value);
      const total=active.reduce((sum,r)=>{let n=Number(field(r).quantity.value);return sum+(Number.isSafeInteger(n)&&n>=0?n:0);},0);
      const summaryLanguage=(requestedLanguage||document.documentElement.dataset.commercialLang||document.documentElement.lang||'en').split('-')[0];
      const summaryLabels={en:['products','requested containers'],fr:['produits','contenants demandés'],ar:['منتجات','عبوة مطلوبة']}[summaryLanguage]||['products','requested containers'];
      root.querySelector('[data-bp-selection-summary]').textContent=active.length+' '+summaryLabels[0]+' · '+total.toLocaleString('en-US')+' '+summaryLabels[1];
      root.querySelector('[data-bp-selection-payload]').value=active.map(r=>{const f=field(r);return f.product.value+' | '+f.quantity.value+' containers | '+(primaryFor(f.product.value)?.text||'Pack confirmation required')+' | '+f.container.value;}).join('\n');
      for(const choice of choices)choice.checked=active.some(r=>field(r).product.value===choice.value);
      const selected=active.map(r=>field(r).product.value);
      for(const row of rows){const f=field(row);for(const o of f.product.options)o.disabled=Boolean(o.value&&o.value!==f.product.value&&selected.includes(o.value));}
      const guidance=root.querySelector('[data-bp-product-guidance]');
      const guidanceText={
        en:['Choose a product first to enable quantity, pack size and container format.','Set the quantity for each selected product. Pack size follows the approved product presentation; other formats require written confirmation.'],
        fr:['Sélectionnez d’abord un produit pour activer la quantité, le format et le conditionnement.','Indiquez la quantité pour chaque produit sélectionné. Le format correspond à la présentation approuvée ; tout autre conditionnement nécessite une confirmation écrite.'],
        ar:['اختر المنتج أولًا لتفعيل كمية العبوات وحجمها وشكلها.','حدد كمية كل منتج مختار. حجم العبوة يتبع العرض المعتمد للمنتج؛ الأشكال الأخرى تتطلب تأكيدًا كتابيًا.']
      }[summaryLanguage]||null;
      if(guidance&&guidanceText)guidance.textContent=guidanceText[active.length?1:0];
      add.hidden=!rows.some(r=>r.hidden);
    }
    function render(){
      const entries=Array.from(state.entries());
      rows.forEach((row,index)=>{
        const f=field(row),entry=entries[index];row.hidden=Boolean(!entry&&index>0);f.product.disabled=row.hidden;f.product.required=Boolean(entry||index===0);f.product.value=entry?entry[0]:'';
        f.quantity.value=entry?entry[1].quantity:'';f.container.value=entry?entry[1].container:'';sync(row);
      });summary();
    }
    rows.forEach(row=>{
      const f=field(row);
      f.product.addEventListener('change',()=>{sync(row);snapshot();render();});
      for(const type of ['input','change'])f.quantity.addEventListener(type,()=>{validate(row,true);snapshot();summary();});
      f.container.addEventListener('change',()=>{snapshot();summary();});
      f.pack.addEventListener('change',()=>{validate(row,true);summary();});
      const remove=row.querySelector('[data-bp-remove]');
      if(remove)remove.addEventListener('click',()=>{snapshot();state.delete(f.product.value);render();add.focus();});
    });
    for(const choice of choices)choice.addEventListener('change',()=>{
      snapshot();
      if(choice.checked&&state.size<rows.length)state.set(choice.value,{quantity:'3000',container:''});else state.delete(choice.value);
      render();
    });
    root.querySelector('[data-bp-select-all]').addEventListener('click',()=>{snapshot();const previous=new Map(state);state.clear();for(const name of names)state.set(name,previous.get(name)||{quantity:'3000',container:''});render();});
    root.querySelector('[data-bp-clear]').addEventListener('click',()=>{state.clear();render();});
    root.querySelector('[data-bp-search]').addEventListener('input',event=>{
      const query=event.target.value.toLowerCase().trim();for(const choice of choices)choice.closest('[data-bp-choice-label]').hidden=!choice.value.toLowerCase().includes(query);
    });
    add.addEventListener('click',()=>{const row=rows.find(r=>r.hidden);if(!row)return;row.hidden=false;const f=field(row);f.product.disabled=false;f.product.required=false;sync(row);summary();f.product.focus();});
    for(const requested of params.getAll('product')){
      const name=names.find(n=>normalize(n)===normalize(requested));
      if(name)state.set(name,{quantity:params.get('quantity')||'3000',container:['Bottles','Packages'].includes(params.get('container'))?params.get('container'):''});
    }
    render();for(const row of rows)if(!row.hidden&&field(row).product.value)validate(row,true);
    const catalogue=params.get('catalogue');
    if(['all','women','men','kids','50plus'].includes(catalogue)){
      root.querySelector('[data-bp-catalogue-request]').value=catalogue;
      const message=form.querySelector('#bp-message');
      if(message&&!message.value.trim())message.value='Please send the current '+(catalogue==='all'?'full portfolio':catalogue==='50plus'?'50+':catalogue)+' catalogue for my market.';
    }
    form.addEventListener('submit',event=>{
      let valid=true;for(const row of rows)if(!row.hidden&&!validate(row,true))valid=false;summary();
      if(!valid||!form.checkValidity()){event.preventDefault();event.stopImmediatePropagation();form.reportValidity();}
    },true);
    root.querySelectorAll('[data-bp-message]').forEach(link=>link.addEventListener('click',()=>{const message=form.querySelector('#bp-message');if(!message.value.trim())message.value=link.dataset.bpMessage;}));
    document.addEventListener('britanica:language-preview',event=>requestAnimationFrame(()=>summary(event.detail?.lang)));
    const status=form.querySelector('.bp__success,.bp__errors');if(status)status.focus({preventScroll:false});
  }
  function start(){initPartnerPage();initDirectEmail();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["britanica-global-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const header = document.querySelector('[data-bgh-header]');
  if (!header) return;
  const menu = header.querySelector('.bgh-header__menu');
  const update = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', update, {passive:true});
  update();
  header.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {if(menu) menu.open = false;}));
  header.addEventListener('keydown', event => {if(event.key === 'Escape' && menu?.open){menu.open=false;menu.querySelector('summary').focus();}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["britanica-global-house"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    const root = document.querySelector('[data-bgh-root]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-bgh-product-card]')];
    const filters = [...root.querySelectorAll('[data-bgh-filter]')];
    const status = root.querySelector('[data-bgh-filter-status]');
    const expand = root.querySelector('[data-bgh-expand]');
    const filterBar = root.querySelector('[data-bgh-filters]');
    let audience = 'all';
    let expanded = false;
    const apply = () => {
      let matched = 0;
      let shown = 0;
      cards.forEach(card => {
        const match = audience === 'all' || card.dataset.bghAudience.split(',').includes(audience);
        if (match) matched += 1;
        const visible = match && (audience !== 'all' || expanded || matched <= 6);
        card.hidden = !visible;
        if (visible) shown += 1;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bghFilter === audience)));
      expand.hidden = audience !== 'all';
      expand.setAttribute('aria-expanded', String(expanded));
      expand.textContent = expanded ? expand.dataset.showLess : expand.dataset.showAll;
      status.textContent = audience !== 'all' ? status.dataset.selected.replace('{count}', String(shown)) : expanded ? status.dataset.all : status.dataset.preview.replace('{count}', String(shown));
    };
    filters.forEach(button => button.addEventListener('click', () => { audience = button.dataset.bghFilter; apply(); }));
    root.querySelectorAll('[data-bgh-filter-link]').forEach(link => link.addEventListener('click', () => { audience = link.dataset.bghFilterLink; apply(); }));
    expand.addEventListener('click', () => {
      expanded = !expanded;
      apply();
      if (!expanded) root.querySelector('#portfolio').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    });
    root.querySelectorAll('[data-bgh-enquiry-product]').forEach(link => link.addEventListener('click', () => {
      const field = root.querySelector('#bgh-message');
      const selectedProduct = root.querySelector('#bgh-enquiry-product');
      if (selectedProduct) selectedProduct.value = link.dataset.bghEnquiryProduct;
      if (field && (!field.value.trim() || /^(BriVision|BriGlow™|BriMag Kids™) — $/.test(field.value))) field.value = link.dataset.bghEnquiryProduct + ' — ';
    }));
    root.querySelectorAll('[data-bgh-interest]').forEach(link => link.addEventListener('click', () => {
      const interest = root.querySelector('#bgh-interest');
      if (!interest) return;
      interest.selectedIndex = Number(link.dataset.bghInterest);
      interest.dispatchEvent(new Event('change', {bubbles:true}));
      requestAnimationFrame(() => interest.focus({preventScroll:true}));
    }));
    filterBar.hidden = false;
    apply();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

(() => {
  const active = new Map();
  const start = hero => {
    if (active.has(hero)) return;
    const button = hero.querySelector('[data-bgh-motion-toggle]');
    if (!button) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let manuallyPaused = false;
    let visible = false;
    const render = () => {
      const paused = manuallyPaused || reduced.matches;
      hero.dataset.bghMotionState = !paused && visible && !document.hidden ? 'playing' : 'paused';
      button.hidden = reduced.matches;
      button.setAttribute('aria-pressed', String(manuallyPaused));
      button.setAttribute('aria-label', manuallyPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
    };
    const toggle = () => { manuallyPaused = !manuallyPaused; render(); };
    button.addEventListener('click', toggle);
    reduced.addEventListener('change', render);
    document.addEventListener('visibilitychange', render);
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.target === hero) visible = entry.isIntersecting;
        render();
      }, {threshold: 0});
      observer.observe(hero);
    } else {
      visible = true;
    }
    active.set(hero, () => {
      observer?.disconnect();
      button.removeEventListener('click', toggle);
      reduced.removeEventListener('change', render);
      document.removeEventListener('visibilitychange', render);
      hero.dataset.bghMotionState = 'paused';
      button.hidden = true;
    });
    render();
  };
  const boot = () => {
    for (const [hero, dispose] of active) if (!hero.isConnected) { dispose(); active.delete(hero); }
    document.querySelectorAll('.bgh__hero--cinematic[data-bgh-motion]').forEach(start);
  };
  const unload = event => {
    for (const [hero, dispose] of active) if (event.target.contains(hero)) { dispose(); active.delete(hero); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', unload);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
